import { Form } from "antd";
import { useContext, useEffect, useState } from "react";
import CustomDropdown from "../../../component/CustomDropdown";
import CustomSingleDropdown from "../../../component/CustomeSigleDropDown";
import FilledButton from "../../../component/FilledButton";
import FormInput from "../../../component/FormInput";
import { ContextState } from "../../../layout";
import { DatePicker, Select } from 'antd'
import { ReactComponent as DropArrow } from '../../../assets/images/drop_arrow.svg';
import { Pre_clg_extend_user_course, cert_extend_user_course } from '../../../api/courses'
import moment from "moment";

const AddUser = ({ btnLoader, userId, attachCourse, errorData, handleError, handleAddUser, category, handleChange, formData, handleModalClose, setFormRef, startDateDataFromCourse, handleStartDateChange, courseAttendee, courseDeta, handleOpenModal }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false)
    const { contextReducer } = useContext(ContextState);



    const onSubmit = (value) => {
        const newData = {
            user_id: value.user_id,
            course_id: courseDeta?._id,
            date: moment(value?.course_end_date).format("MM/DD/YYYY")
        };
        setLoading(true)

        const action = contextReducer.cms_type === 'pre-college'
            ? Pre_clg_extend_user_course(newData)
            : cert_extend_user_course(newData);
        action.then(res => {
            if (res.data.status === 200) {
                form.resetFields();
                handleOpenModal('ErrorPop', { header: "Info", body: res.data.message });
                setLoading(false)
            }
        }).catch(err => {
            setLoading(false)
            handleOpenModal('ErrorPop', { header: "Info", body: err.data.message });
        });

    }
    const disablePastDates = (current) => {
        return current && current < moment().startOf('day');
    };

    return (
        <div className="modal_body">
            <div className="extend_course ">
                <Form
                    form={form}
                    name="register"
                    onFinish={onSubmit}
                    onReset={handleModalClose}
                    scrollToFirstError
                    className="attached_courses-add_skill"
                    initialValues={formData}
                >
                    <h2>{"Extend Course"}</h2>

                    <Form.Item
                        name="user_id"
                        label="User *"
                        rules={[{ required: true, message: "Please select a User" }]}
                        className="extend_course_user"

                    >
                        <Select
                            placeholder="Select User"
                            suffixIcon={<DropArrow />}
                            name="user_id"
                            showSearch
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                            onChange={(e) => {
                                const detDeta = courseAttendee.find((data) => data.user_id === e);
                                if (detDeta) {
                                    form.setFieldsValue({
                                        course_end_date: detDeta.course_end_date ? moment(detDeta.course_end_date) : null,
                                    });
                                } else {
                                    form.setFieldsValue({
                                        date: null,
                                    });
                                }
                            }}
                            className=" skill_multiselect"
                        >
                            {courseAttendee.map(user => (
                                <Select.Option key={user.user_id} value={user.user_id}>
                                    {user.email}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="course_end_date"
                        label="Course End Date *"
                        className="course_end_date"
                        rules={[{ required: true, message: "Please select a Course End Date" }]}
                    >
                        <DatePicker disabledDate={disablePastDates} format="MM/DD/YYYY" />
                    </Form.Item>

                    <div className="form_group form_footer d_flex_center">
                        <button type="reset" className="btn btn_gray">
                            Cancel
                        </button>
                        <FilledButton
                            type="submit"
                            loading={loading}
                            value={"submit"}
                            className="btn btn_primary"
                        />
                    </div>
                </Form>
            </div>
        </div>

    )
};

export default AddUser;